import { action } from 'satcheljs/lib/legacy';
import getFolderViewStateFromId from '../selectors/getFolderViewStateFromId';
/*
 * Sets folder node expansion state
 * @param folderId the folder whose expansion state we are modifying
 * @param isExpanded the value to set for the expansion state
*/
export default action('setFolderViewExpansionState')(function setFolderViewExpansionState(folderId, isExpanded) {
    var viewState = getFolderViewStateFromId(folderId);
    viewState.isExpanded = isExpanded;
});
//# sourceMappingURL=setFolderViewExpansionState.js.map